<template>
	<div class="content" v-if="item">
		<div class="section">
			<div class="section-tit">
				{{ item.cate_name }}
				<div class="right">
					<!-- CJ/CK 넘기기: 이전글=목록에서 한 칸 위, 다음글=한 칸 아래(고정글 정렬까지 목록과 동일).
				     순회 범위는 카테고리 전체 — 상태탭·검색 필터는 반영하지 않는다.
				     목록 양끝 글에서는 해당 버튼이 비활성. -->
					<button
						type="button"
						class="btn btn-sm btn-light"
						:disabled="!item.prev_post"
						:title="item.prev_post ? item.prev_post.title : '이전 글이 없습니다'"
						@click="goNeighbor(item.prev_post)"
					>
						<b-icon-chevron-up />이전글
					</button>
					<button
						type="button"
						class="btn btn-sm btn-light"
						:disabled="!item.next_post"
						:title="item.next_post ? item.next_post.title : '다음 글이 없습니다'"
						@click="goNeighbor(item.next_post)"
					>
						<b-icon-chevron-down />다음글
					</button>
					<button type="button" class="btn btn-sm btn-secondary" @click="btnList">목록</button>
					<button v-if="item.can_pin" type="button" class="btn btn-sm btn-light" @click="btnPin">
						{{ item.pin_flag === 'Y' ? '고정 해제' : '상단 고정' }}
					</button>
					<button v-if="item.can_edit" type="button" class="btn btn-sm btn-primary" @click="btnEdit">수정</button>
					<button v-if="item.can_edit" type="button" class="btn btn-sm btn-danger" @click="btnDelete">삭제</button>
				</div>
			</div>

			<table class="table type-input">
				<colgroup>
					<col width="12%" /><col width="38%" /><col width="12%" /><col width="38%" />
				</colgroup>
				<tr>
					<th>제목</th>
					<td colspan="3">
						<span v-if="item.pin_flag === 'Y'" class="txt-c--red">[고정]</span>
						<span v-if="item.notice_all_flag === 'Y'" class="txt-c--red">[전체공지]</span>
						{{ item.title }}
					</td>
				</tr>
				<tr>
					<th>작성자</th>
					<td>{{ item.reg_mem_name }} {{ item.reg_mem_rank_name }}</td>
					<th>등록일</th>
					<td>
						{{ $datetimeFormat(item.reg_date) }}
						<span v-if="item.mod_date" class="txt-c--grey">(수정 {{ $datetimeFormat(item.mod_date) }})</span>
					</td>
				</tr>
				<tr>
					<th>조회</th>
					<td>{{ item.view_cnt }}</td>
					<th>확인</th>
					<td>
						<template v-if="item.confirm_flag === 'Y'">
							{{ item.confirm_cnt }} / {{ item.total_mem_cnt }}명
							<button
								v-if="item.can_view_read_list"
								type="button"
								class="btn btn-xsm btn-light"
								@click="openReadList"
							>
								확인현황
							</button>
						</template>
						<span v-else class="txt-c--grey">-</span>
					</td>
				</tr>
			</table>
		</div>

		<!-- ── B-10 ~ B-13 추천매물 정보 (조회 시점 조인 = 항상 최신) ──────────── -->
		<div class="section" v-if="item.item_flag === 'Y'">
			<div class="section-tit">
				추천 매물
				<div class="right">
					<!-- B-13 추천 상태 (작성자·관리자 수동 지정) -->
					<select
						v-if="item.can_edit"
						v-model="statusEdit"
						class="form-control select sm"
						@change="btnStatus"
					>
						<option value="open">추천중</option>
						<option value="hold">보류</option>
						<option value="done">거래완료</option>
					</select>
					<!-- B-11 원본 매물 상세페이지 바로가기 -->
					<button v-if="!item.item_deleted" type="button" class="btn btn-sm btn-secondary" @click="openOrigin">
						원본 매물 상세보기
					</button>
					<!-- B-14 관심(좋아요) -->
					<button type="button" class="btn btn-sm" v-bind:class="likeBtnClass" @click="btnLike">
						<b-icon-heart-fill v-if="item.my_like_flag === 'Y'" />
						<b-icon-heart v-else />
						관심 {{ item.like_cnt }}
					</button>
				</div>
			</div>

			<div v-if="item.item_deleted" class="txt-c--red">
				원본 매물이 삭제되었습니다. 매물 정보를 표시할 수 없으며 수정도 제한됩니다.
			</div>
			<table v-else class="table type-input">
				<colgroup>
					<col width="12%" /><col width="38%" /><col width="12%" /><col width="38%" />
				</colgroup>
				<tr>
					<th>물건번호</th>
					<td>{{ item.building_uid }}</td>
					<th>물건명</th>
					<td>{{ item.item_name }}</td>
				</tr>
				<tr>
					<th>주소</th>
					<td colspan="3">
						{{ $normalizeAddr(item.item_jibun_addr) }}
						<span v-if="item.item_road_addr" class="txt-c--grey">({{ $normalizeAddr(item.item_road_addr) }})</span>
					</td>
				</tr>
				<tr>
					<th>매매가</th>
					<td>
						{{ $formatMoney(item.item_sell_price, $MONEY_FORMAT_TYPE.MUCH) }}
						<span v-if="priceDiff" v-bind:class="priceDiff.cls">
							(등록시 {{ $formatMoney(item.snapshot_price, $MONEY_FORMAT_TYPE.MUCH) }} → {{ priceDiff.text }})
						</span>
					</td>
					<th>평당가</th>
					<td>{{ $formatNumber(item.item_py_price) }}</td>
				</tr>
				<tr>
					<th>대지면적(평)</th>
					<td>{{ $formatArea(item.item_land_size_p) }}</td>
					<th>연면적(평)</th>
					<td>{{ $formatArea(item.item_total_size_p) }}</td>
				</tr>
				<tr>
					<th>임대수익률</th>
					<td>{{ item.item_income_rate != null ? item.item_income_rate + '%' : '' }}</td>
					<th>담당자</th>
					<td>{{ item.item_mgr_name }} {{ item.item_mgr_rank_name }}</td>
				</tr>
				<tr>
					<th>매물 상태</th>
					<td>{{ $ITEM_STATE[item.item_sell_status] }}</td>
					<th>추천 상태</th>
					<td>
						<span v-bind:class="statusClass">{{ RECO_STATUS[item.recommend_status_view] }}</span>
						<span v-if="item.recommend_status_manual === 'Y'" class="txt-c--grey">(수동 지정)</span>
						<span v-else class="txt-c--grey">(매물 상태 자동 반영)</span>
					</td>
				</tr>
				<tr v-if="item.reco_reason">
					<th>추천 사유</th>
					<td colspan="3"><div class="text-pre">{{ item.reco_reason }}</div></td>
				</tr>
				<tr v-if="item.reco_point">
					<th>투자 포인트</th>
					<td colspan="3"><div class="text-pre">{{ item.reco_point }}</div></td>
				</tr>
				<tr v-if="item.reco_etc">
					<th>참고사항</th>
					<td colspan="3"><div class="text-pre">{{ item.reco_etc }}</div></td>
				</tr>
			</table>
		</div>

		<!-- ── 매수요청: 요청 조건 — 작성자는 조건만 등록한다 ─────────────────── -->
		<div class="section" v-if="isRequestCate">
			<div class="section-tit">
				요청 조건
				<div class="right">
					<!-- 요청 상태 (작성자·관리자 수동 지정 — 추천매물이 여러 개라 자동전환 없음) -->
					<select v-if="item.can_edit" v-model="statusEdit" class="form-control select sm" @change="btnStatus">
						<option value="open">구하는중</option>
						<option value="hold">보류</option>
						<option value="done">완료</option>
					</select>
				</div>
			</div>
			<table class="table type-input">
				<colgroup>
					<col width="12%" /><col width="38%" /><col width="12%" /><col width="38%" />
				</colgroup>
				<tr>
					<th>예산</th>
					<td>{{ item.req_budget || '-' }}</td>
					<th>희망 지역</th>
					<td>{{ item.req_region || '-' }}</td>
				</tr>
				<tr>
					<th>용도</th>
					<td>{{ item.req_use || '-' }}</td>
					<th>희망 면적</th>
					<td>{{ item.req_area || '-' }}</td>
				</tr>
				<tr>
					<th>요청 상태</th>
					<td colspan="3">
						<span v-bind:class="statusClass">{{ REQ_STATUS[item.recommend_status_view] }}</span>
					</td>
				</tr>
			</table>
		</div>

		<!-- ── 매수요청: 추천매물 목록 — 조건에 맞는 매물을 아는 직원이 연결한다.
		     매물 정보는 조회 시점 조인(항상 최신), 추천자·추천일 기록. ────────── -->
		<div class="section" v-if="isRequestCate">
			<div class="section-tit">
				추천매물 <span class="sub">{{ requestItems.length }}건</span>
				<div class="right">
					<button type="button" class="btn btn-sm btn-primary" @click="openReqPopup">추천매물 추가</button>
				</div>
			</div>
			<div class="table-wrap" v-if="requestItems.length">
				<table class="table sm">
					<colgroup>
						<col width="5%" /><col width="7%" /><col width="19%" /><col width="8%" />
						<col width="6%" /><col width="6%" /><col width="7%" /><col width="7%" />
						<col width="14%" /><col width="9%" /><col width="7%" /><col width="5%" />
					</colgroup>
					<tr>
						<th>구분</th>
						<th>물건번호</th>
						<th>물건명 / 주소</th>
						<th>매매가</th>
						<th>대지(평)</th>
						<th>연면적(평)</th>
						<th>담당자</th>
						<th>매물 상태</th>
						<th>추천 코멘트</th>
						<th>추천자</th>
						<th>추천일</th>
						<th>삭제</th>
					</tr>
					<tr v-for="ri in requestItems" :key="'ri_' + ri.board_request_item_uid">
						<td>{{ KIND_LABEL[ri.item_kind] }}</td>
						<td>{{ ri.building_uid }}</td>
						<td class="txt-left">
							<template v-if="!ri.item_deleted">
								{{ ri.item_name }}
								<button type="button" class="btn btn-xsm btn-light" @click="openReqOrigin(ri)">원본 보기</button>
								<br /><span class="txt-c--grey">{{ $normalizeAddr(ri.item_jibun_addr) }}</span>
							</template>
							<span v-else class="txt-c--red">삭제된 매물</span>
						</td>
						<td>{{ $formatMoney(ri.item_sell_price, $MONEY_FORMAT_TYPE.MUCH) }}</td>
						<td>{{ $formatArea(ri.item_land_size_p) }}</td>
						<td>{{ $formatArea(ri.item_total_size_p) }}</td>
						<td>{{ ri.item_mgr_name }}</td>
						<td>{{ $ITEM_STATE[ri.item_sell_status] }}</td>
						<td class="txt-left"><div class="text-pre">{{ ri.memo }}</div></td>
						<td>{{ ri.reg_mem_name }} {{ ri.reg_mem_rank_name }}</td>
						<td>{{ $dateFormat(ri.reg_date) }}</td>
						<td>
							<button
								v-if="ri.can_delete"
								type="button"
								class="btn btn-xsm btn-danger"
								@click="deleteReqItem(ri)"
							>
								삭제
							</button>
						</td>
					</tr>
				</table>
			</div>
			<div v-else class="txt-c--grey">
				아직 추천된 매물이 없습니다. 조건에 맞는 매물을 알고 있다면 '추천매물 추가' 로 연결해 주세요.
			</div>
		</div>

		<div class="section">
			<div class="section-tit">내용</div>
			<!-- 본문은 표가 아니라 읽는 글 — reading 타이포(post-body)로 조판 (가독성 민원) -->
			<div class="text-pre post-body">{{ item.memo }}</div>

			<!-- B-6 첨부: 이미지는 미리보기, 동영상은 인라인 재생, 그 외는 다운로드 -->
			<template v-if="files.length">
				<div class="section-tit sub mt-3">첨부파일 ({{ files.length }})</div>
				<div class="image-list" v-if="imageFiles.length">
					<div v-for="f in imageFiles" :key="'img_' + f.id">
						<!-- 미리보기는 320px 로 줄여 보여주므로(연락처표 등은 안 읽힘) 클릭하면 원본 크기로 연다 -->
						<img
							v-if="blobUrls[f.id]"
							:src="blobUrls[f.id]"
							:alt="f.org_name"
							:title="f.org_name + ' — 클릭하면 원본 크기로 열립니다'"
							style="max-width: 320px; max-height: 240px; cursor: pointer"
							@click="openFull(f)"
						/>
						<span v-else class="txt-c--grey">{{ f.org_name }} 불러오는 중…</span>
					</div>
				</div>
				<!-- 동영상은 클릭 시에만 받아온다. 첨부 상한이 200MB 라 상세 진입만으로
				     자동 다운로드되면 회선/메모리를 그대로 잡아먹는다. -->
				<div v-for="f in videoFiles" :key="'vid_' + f.id" class="mt-2">
					<video v-if="blobUrls[f.id]" :src="blobUrls[f.id]" controls style="max-width: 640px"></video>
					<button v-else type="button" class="btn btn-sm btn-light" @click="loadBlob(f)">
						<b-icon-play-circle />동영상 재생 ({{ f.org_name }} · {{ sizeText(f.size) }})
					</button>
					<div class="txt-c--grey">{{ f.org_name }}</div>
				</div>
				<!-- 다운로드는 첨부 전체 대상 — 이미지/동영상도 미리보기만으로는 파일을 "받을" 수 없다
				     (임직원 연락처를 이미지로 올렸는데 열람자가 저장할 방법이 없던 실사용 민원). -->
				<div class="mt-2">
					<button
						v-for="f in files"
						:key="'file_' + f.id"
						type="button"
						class="btn btn-xsm btn-light"
						@click="downFile(f)"
					>
						<b-icon-download />{{ f.org_name }} ({{ sizeText(f.size) }})
					</button>
				</div>
			</template>

			<!-- B-4 확인 버튼 — 전체공지 상세 하단 -->
			<div class="btn-wrap" v-if="item.notice_all_flag === 'Y'">
				<button v-if="!item.my_confirm_date" type="button" class="btn btn-primary" @click="btnConfirm">
					확인했습니다
				</button>
				<span v-else class="txt-c--blue">
					{{ $datetimeFormat(item.my_confirm_date) }} 에 확인하셨습니다.
				</span>
			</div>
		</div>

		<!-- B-15 댓글 -->
		<div class="section">
			<div class="section-tit">댓글 <span class="sub">{{ comments.length }}건</span></div>
			<div class="table-wrap" v-if="comments.length">
				<table class="table sm">
					<colgroup>
						<col width="18%" /><col width="15%" /><col width="59%" /><col width="8%" />
					</colgroup>
					<tr v-for="c in comments" :key="'cm_' + c.board_comment_uid">
						<td>{{ c.reg_mem_name }} {{ c.reg_mem_rank_name }}</td>
						<td>{{ $datetimeFormat(c.reg_date) }}</td>
						<td class="txt-left"><div class="text-pre post-body">{{ c.memo }}</div></td>
						<td>
							<button
								v-if="isMaster || c.reg_mem_uid == myUid"
								type="button"
								class="btn btn-xsm btn-danger"
								@click="deleteComment(c)"
							>
								삭제
							</button>
						</td>
					</tr>
				</table>
			</div>
			<div class="d-flex mt-2">
				<textarea class="form-control textarea" rows="2" v-model="commentMemo" placeholder="댓글을 입력하세요"></textarea>
				<!-- textarea 가 폭을 다 차지해 버튼이 한 글자 폭으로 눌리며 "등/록" 세로 줄바꿈되던 문제 -->
				<button type="button" class="btn btn-primary text-nowrap m-l--1" @click="addComment">등록</button>
			</div>
		</div>

		<!-- 매수요청: 추천매물 추가 팝업 — 기존 매물 DB 검색(작성 화면과 같은 3-way 검색) -->
		<div v-if="reqPopup" class="popup-wrap">
			<div class="dim" @click="reqPopup = false"></div>
			<div class="popup">
				<div class="popup-tit">
					추천매물 추가
					<button type="button" class="btn btn-close" @click="reqPopup = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<div class="search-top">
						<div class="left">
							<label class="input-label">구분</label>
							<select v-model="reqSearch.kind" class="form-control select sm" @change="onReqKindChange">
								<option value="building">매매</option>
								<option value="rent_building">임대</option>
							</select>
							<label class="input-label">물건번호</label>
							<input class="form-control xsm" type="text" v-model="reqSearch.bid" @keyup.enter="searchReqItem" />
							<label class="input-label">물건명</label>
							<input class="form-control sm" type="text" v-model="reqSearch.name" @keyup.enter="searchReqItem" />
							<label class="input-label">주소</label>
							<input class="form-control sm" type="text" v-model="reqSearch.addr" @keyup.enter="searchReqItem" />
						</div>
						<div class="right">
							<button type="button" class="btn btn-primary btn-sm" @click="searchReqItem">검색</button>
						</div>
					</div>
					<div class="d-flex align-items-center mt-2">
						<label class="input-label text-nowrap">추천 코멘트</label>
						<input
							class="form-control m-l--1"
							type="text"
							v-model="reqMemo"
							maxlength="500"
							placeholder="(선택) 추천 사유를 짧게 남기면 함께 저장됩니다"
						/>
					</div>
					<div class="table-wrap mt-2" v-if="reqSearchList.length">
						<table class="table sm">
							<tr>
								<th>물건번호</th>
								<th>상태</th>
								<th>물건명</th>
								<th>주소</th>
								<th>매매가</th>
								<th>대지(평)</th>
								<th>연면적(평)</th>
								<th>담당자</th>
								<th>추천</th>
							</tr>
							<tr v-for="b in reqSearchList" :key="'rs_' + b.building_uid">
								<td>{{ b.building_uid }}</td>
								<td>{{ $ITEM_STATE[b.sell_status] }}</td>
								<td>{{ b.building_name }}</td>
								<td>{{ $normalizeAddr(b.jibun_addr) }}</td>
								<td>{{ $formatMoney(b.sell_price, $MONEY_FORMAT_TYPE.MUCH) }}</td>
								<td>{{ $formatArea(b.land_size_p) }}</td>
								<td>{{ $formatArea(b.total_size_p) }}</td>
								<td>{{ b.building_mem_name }}</td>
								<td>
									<button
										v-if="!isLinked(b)"
										type="button"
										class="btn btn-xsm btn-primary"
										@click="addReqItem(b)"
										:disabled="reqAdding"
									>
										추천
									</button>
									<span v-else class="txt-c--grey">추가됨</span>
								</td>
							</tr>
						</table>
					</div>
					<div v-if="reqSearched && !reqSearchList.length" class="txt-c--grey mt-2">검색 결과가 없습니다.</div>
					<div class="btn-wrap">
						<button type="button" class="btn btn-sm btn-secondary" @click="reqPopup = false">닫기</button>
					</div>
				</div>
			</div>
		</div>

		<!-- B-5 확인현황 팝업 -->
		<div v-if="readPopup" class="popup-wrap">
			<div class="dim" @click="readPopup = false"></div>
			<div class="popup sm">
				<div class="popup-tit">
					확인현황
					<button type="button" class="btn btn-close" @click="readPopup = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<div class="section-tit sub">
						확인 {{ readInfo.confirmed }} / 전체 {{ readInfo.total }}명
						<span class="sub">열람만 함 {{ readInfo.viewed_only }}명</span>
					</div>
					<div class="table-wrap">
						<table class="table sm">
							<tr>
								<th>이름</th>
								<th>팀</th>
								<th>직급</th>
								<th>열람일시</th>
								<th>확인일시</th>
							</tr>
							<tr v-for="r in readInfo.list" :key="'rd_' + r.mem_uid">
								<td>{{ r.mem_name }}</td>
								<td>{{ r.team_name }}</td>
								<td>{{ r.mem_rank_name }}</td>
								<td>{{ r.view_date ? $datetimeFormat(r.view_date) : '-' }}</td>
								<td>
									<span v-if="r.confirm_date" class="txt-c--blue">{{ $datetimeFormat(r.confirm_date) }}</span>
									<span v-else class="txt-c--red">미확인</span>
								</td>
							</tr>
						</table>
					</div>
					<div class="btn-wrap">
						<button type="button" class="btn btn-sm btn-secondary" @click="readPopup = false">닫기</button>
						<button
							v-if="readInfo.total - readInfo.confirmed > 0"
							type="button"
							class="btn btn-sm btn-primary"
							:disabled="reminding"
							@click="btnRemind"
						>
							{{ reminding ? '발송 중…' : `미확인자 ${readInfo.total - readInfo.confirmed}명에게 재알림` }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- 조회 실패(삭제·권한 없음·일시 오류 — 쪽지 딥링크로 진입 가능) — 빈 화면 대신 안내를 남긴다.
	     API 래퍼가 실패 종류를 구분해 주지 않으므로 문구는 두 경우를 모두 정직하게 덮는다. -->
	<div v-else-if="notFound" class="content">
		<div class="section">
			<div class="section-tit">게시판</div>
			<p class="txt-c--grey mb-2">게시글을 불러오지 못했습니다. 삭제되었거나 일시적인 오류일 수 있습니다.</p>
			<button type="button" class="btn btn-sm btn-secondary" @click="btnList">목록으로</button>
		</div>
	</div>
</template>

<script>
const RECO_STATUS = { open: '추천중', hold: '보류', done: '거래완료' };
// 새 탭 원본 보기가 안전한(스크립트가 실행되지 않는) 래스터 이미지 타입.
const SAFE_VIEW_TYPES = new Set(['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/bmp', 'image/avif']);
// 매수요청 상태 라벨 — 같은 컬럼(open|hold|done)을 쓰지만 화면 표현이 다르다.
const REQ_STATUS = { open: '구하는중', hold: '보류', done: '완료' };
const KIND_LABEL = { building: '매매', rent_building: '임대' };

export default {
	name: 'BoardDetail',
	data() {
		return {
			RECO_STATUS,
			REQ_STATUS,
			KIND_LABEL,
			item: null,
			notFound: false,
			files: [],
			comments: [],
			commentMemo: '',
			statusEdit: 'open',
			readPopup: false,
			readInfo: { list: [], total: 0, confirmed: 0, viewed_only: 0 },
			// 재알림 이중발송 잠금 (Codex 헌트: 더블클릭이 같은 미확인자에게 쪽지 2통)
			reminding: false,
			// 넘기기(CJ)로 글을 빠르게 전환하면 앞선 상세 응답이 늦게 도착해 현재 글을
			// 덮는다 — 마지막 요청만 반영 (Board.vue listSeq 와 같은 패턴, Codex P1).
			loadSeq: 0,
			// 첨부 미리보기용 blob URL 캐시 (id → objectURL)
			blobUrls: {},
			// ── 매수요청: 추천매물 ─────────────────────────────────────────
			requestItems: [],
			reqPopup: false,
			reqSearch: { kind: 'building', bid: '', name: '', addr: '' },
			reqSearchList: [],
			// 결과가 '어느 구분으로 검색된 것인지'를 결과와 함께 보관한다 — 검색 응답이 오기 전에
			// 구분을 바꾸면 select 의 현재값과 결과가 어긋나, 매매 결과의 번호가 임대로 연결되는
			// 오연결이 생긴다(Codex P1). 추가 요청은 항상 이 값을 쓴다.
			reqSearchKind: 'building',
			// 이 화면에서 추가에 성공한 "구분:물건번호" — 목록 재조회가 실패해도 버튼을 잠근다.
			reqAdded: new Set(),
			reqSearched: false,
			reqMemo: '',
			reqAdding: false,
		};
	},
	computed: {
		myUid() {
			return this.$store.getters.getUserInfo.mem_uid;
		},
		isMaster() {
			return this.$store.getters.getUserInfo.mem_type === 'master';
		},
		imageFiles() {
			return this.files.filter(f => f.file_kind === 'image');
		},
		videoFiles() {
			return this.files.filter(f => f.file_kind === 'video');
		},
		likeBtnClass() {
			return this.item && this.item.my_like_flag === 'Y' ? 'btn-danger' : 'btn-light';
		},
		isRequestCate() {
			return !!(this.item && this.item.request_flag === 'Y');
		},
		statusClass() {
			const v = this.item && this.item.recommend_status_view;
			if (v === 'done') return 'txt-c--grey';
			if (v === 'hold') return 'txt-c--orange';
			return 'txt-c--blue';
		},
		priceDiff() {
			if (!this.item) return null;
			const snap = Number(this.item.snapshot_price);
			const cur = Number(this.item.item_sell_price);
			if (!snap || !cur || snap === cur) return null;
			const diff = cur - snap;
			return {
				text: (diff > 0 ? '▲' : '▼') + this.$formatMoney(Math.abs(diff), this.$MONEY_FORMAT_TYPE.MUCH),
				cls: diff > 0 ? 'txt-c--red' : 'txt-c--blue',
			};
		},
	},
	created() {
		this.load();
	},
	watch: {
		// CJ 넘기기: 같은 화면에서 id 만 바뀌면 컴포넌트가 재사용되어 created 가 다시 돌지
		// 않는다 — 라우트 이탈(id undefined)은 건너뛰고, 글 전환 시 글별 상태를 전부 새 글
		// 기준으로 초기화한다. beforeUnmount 가 안 불리므로 blob 해제(최대 200MB 동영상)도
		// 여기서 한다 (Codex P2).
		'$route.params.id'(to) {
			if (this.$route.name !== 'BoardDetail' || !to) return;
			this.item = null;
			this.notFound = false;
			this.files = [];
			this.comments = [];
			this.requestItems = [];
			this.commentMemo = '';
			this.statusEdit = 'open';
			this.readPopup = false;
			this.readInfo = { list: [], total: 0, confirmed: 0, viewed_only: 0 };
			this.reminding = false;
			this.reqPopup = false;
			this.reqSearch = { kind: 'building', bid: '', name: '', addr: '' };
			this.reqSearchKind = 'building';
			this.reqSearchList = [];
			this.reqSearched = false;
			this.reqAdded = new Set();
			this.reqMemo = '';
			this.reqAdding = false;
			this.revokeBlobs();
			this.load();
		},
	},
	beforeUnmount() {
		this.revokeBlobs();
	},
	methods: {
		load() {
			const seq = ++this.loadSeq;
			this.$apiGET('/admin/api/board/item?id=' + this.$route.params.id).then(re => {
				// 글 전환 후 도착한 이전 글 응답은 버린다 — URL 은 A 인데 내용·첨부·댓글이
				// B 로 남고 이후 삭제·좋아요까지 B 를 겨냥하는 경합 (Codex P1).
				if (seq !== this.loadSeq) return;
				if (!re || !re.item) {
					// 404(삭제)뿐 아니라 500·타임아웃도 래퍼가 false 로 돌려주므로 여기로 온다.
					// item 이 null 이면 화면 전체가 비어 버리므로 안내로 대체(문구도 두 경우를 덮는다).
					this.notFound = true;
					return;
				}
				this.item = re.item;
				this.files = re.files || [];
				this.comments = re.comments || [];
				this.requestItems = re.request_items || [];
				this.statusEdit = re.item.recommend_status_view || 'open';
				// 이미지는 보통 작아서 바로 받아 미리보기. 동영상은 버튼 클릭 시에만.
				this.revokeBlobs();
				this.files.filter(f => f.file_kind === 'image').forEach(f => this.loadBlob(f));
			});
		},
		btnList() {
			// notFound 화면에서는 item 이 없으므로 진입 시 쿼리의 탭으로 돌아간다
			const cate = this.item ? this.item.board_category_uid : this.$route.query.cate;
			this.$router.push({ name: 'Board', query: cate ? { cate } : {} });
		},
		// CJ 넘기기: cate 쿼리를 유지해야 '목록' 으로 돌아갈 때 보던 탭이 유지된다.
		goNeighbor(nb) {
			if (!nb) return;
			this.$router.push({ name: 'BoardDetail', params: { id: nb.uid }, query: this.$route.query });
		},
		// 넘기기 도입 후 글별 비동기 콜백이 "다른 글" 위에서 완료될 수 있다 — 요청 시점의
		// uid 와 현재 글이 같을 때만 화면 상태를 만진다 (Codex P2).
		isCurrent(postUid) {
			return !!this.item && Number(this.item.board_post_uid) === Number(postUid);
		},
		btnEdit() {
			this.$router.push({ name: 'BoardWrite', params: { id: this.item.board_post_uid } });
		},
		btnDelete() {
			if (!confirm('게시글을 삭제하시겠습니까?')) return;
			this.$apiPOST('/admin/api/board/delete', { postUid: this.item.board_post_uid }).then(re => {
				if (re !== true) return;
				alert('삭제되었습니다.');
				this.btnList();
			});
		},
		btnPin() {
			const postUid = this.item.board_post_uid;
			const flag = this.item.pin_flag === 'Y' ? 'N' : 'Y';
			this.$apiPOST('/admin/api/board/pin', { postUid, flag }).then(re => {
				if (re !== true || !this.isCurrent(postUid)) return;
				this.item.pin_flag = flag;
			});
		},
		btnStatus() {
			// manual='Y' 로 저장 → 이후 매물 상태 자동전환을 무시(수동 오버라이드).
			this.$apiPOST('/admin/api/board/status', {
				postUid: this.item.board_post_uid,
				status: this.statusEdit,
				manual: 'Y',
			}).then(re => {
				if (re !== true) return;
				this.load();
			});
		},
		btnConfirm() {
			const postUid = this.item.board_post_uid;
			this.$apiPOST('/admin/api/board/confirm', { postUid }).then(re => {
				if (!re || !re.ok || !this.isCurrent(postUid)) return;
				this.item.my_confirm_date = re.confirm_date;
				this.item.confirm_cnt = Number(this.item.confirm_cnt) + 1;
			});
		},
		btnLike() {
			const postUid = this.item.board_post_uid;
			this.$apiPOST('/admin/api/board/like', { postUid }).then(re => {
				if (!re || !re.ok || !this.isCurrent(postUid)) return;
				this.item.my_like_flag = re.like_flag;
				this.item.like_cnt = re.like_cnt;
			});
		},
		openOrigin() {
			const target = this.item.item_kind === 'rent_building' ? '/LeaseMapDetail/' : '/MapDetail/';
			const w = window.screen.availWidth;
			const h = window.screen.availHeight;
			window.open(target + this.item.building_uid, '', `width=${w}, height=${h}, resizable=no, status=no`);
		},
		// ── 매수요청: 추천매물 ────────────────────────────────────────────
		openReqPopup() {
			// 검색 결과만 초기화 — 검색어·구분은 연달아 추가할 때 다시 쓰는 경우가 많아 유지한다.
			this.reqSearchList = [];
			this.reqSearched = false;
			this.reqPopup = true;
		},
		onReqKindChange() {
			// 매매/임대는 서로 다른 테이블 — 구분을 바꾸면 이전 결과가 무의미하다.
			this.reqSearchList = [];
			this.reqSearched = false;
		},
		searchReqItem() {
			// 빈 검색어는 쿼리에서 아예 뺀다 — 공통 bid-guard(J-2, backend/routes/index.js)가
			// bid='' 를 400 으로 차단해서, 빈 bid 를 함께 보내면 물건명·주소 단독 검색이 통째로 막힌다.
			const kind = this.reqSearch.kind;
			const q = new URLSearchParams({ kind });
			for (const k of ['bid', 'name', 'addr']) {
				const t = String(this.reqSearch[k] || '').trim();
				if (t) q.set(k, t);
			}
			if (!q.has('bid') && !q.has('name') && !q.has('addr')) {
				alert('물건번호 · 물건명 · 주소 중 하나를 입력하세요.');
				return;
			}
			this.$apiGET('/admin/api/board/item/search?' + q.toString()).then(re => {
				// 응답 대기 중 구분이 바뀌었으면 버린다 — 매매 결과가 임대 결과처럼 남으면 오연결.
				if (kind !== this.reqSearch.kind) return;
				this.reqSearchKind = kind;
				this.reqSearched = true;
				this.reqSearchList = Array.isArray(re) ? re : [];
			});
		},
		// 이미 이 요청글에 연결된 매물이면 '추가됨' 으로 비활성 표시 (서버도 중복을 거부한다).
		// 방금 추가에 성공한 건(reqAdded)은 목록 재조회가 실패해도 잠긴 상태를 유지한다.
		isLinked(b) {
			if (this.reqAdded.has(this.reqSearchKind + ':' + b.building_uid)) return true;
			return this.requestItems.some(
				ri => ri.item_kind === this.reqSearchKind && Number(ri.building_uid) === Number(b.building_uid)
			);
		},
		addReqItem(b) {
			if (this.reqAdding) return;
			this.reqAdding = true;
			const postUid = this.item.board_post_uid;
			this.$apiPOST('/admin/api/board/request/add', {
				postUid,
				// select 의 현재값이 아니라 이 결과 목록을 만든 구분을 보낸다 (오연결 방지).
				item_kind: this.reqSearchKind,
				building_uid: b.building_uid,
				memo: this.reqMemo,
			})
				.then(re => {
					if (!re || !re.ok || !this.isCurrent(postUid)) return;
					this.reqMemo = '';
					// 추가에 성공한 매물은 목록 재조회 성공 여부와 무관하게 '추가됨' 으로 잠근다 —
					// 재조회가 실패하면 행이 다시 눌리고, 다시 누르면 서버 중복 거부 알림이 뜬다.
					// (목록 표시는 서버 응답만 쓰고, 이 집합은 검색결과 버튼 잠금에만 쓴다.)
					this.reqAdded.add(this.reqSearchKind + ':' + b.building_uid);
					// 목록 갱신이 끝날 때까지 버튼을 잠근다 — '추가됨' 표시 전에 재클릭하면
					// 서버 중복 거부 알림이 떠서 사용자를 놀라게 한다.
					return this.loadRequestItems(postUid);
				})
				.finally(() => {
					this.reqAdding = false;
				});
		},
		// 상세 전체 재조회(load)는 SP_BOARD_VIEW 로 조회수를 또 올린다 → 추천 목록만 갱신.
		// 넘기기로 글이 바뀐 뒤 도착한 응답은 버린다(요청 시점 uid 기준).
		loadRequestItems(postUid) {
			return this.$apiGET('/admin/api/board/request/list?id=' + postUid).then(re => {
				if (Array.isArray(re) && this.isCurrent(postUid)) this.requestItems = re;
			});
		},
		deleteReqItem(ri) {
			if (!confirm('이 추천매물 연결을 삭제하시겠습니까?')) return;
			const postUid = this.item.board_post_uid;
			this.$apiPOST('/admin/api/board/request/delete', { uid: ri.board_request_item_uid }).then(re => {
				if (re !== true || !this.isCurrent(postUid)) return;
				// 연결이 풀렸으므로 '방금 추가' 잠금도 해제한다(다시 추가할 수 있어야 한다).
				this.reqAdded.delete(ri.item_kind + ':' + ri.building_uid);
				this.loadRequestItems(postUid);
			});
		},
		openReqOrigin(ri) {
			const target = ri.item_kind === 'rent_building' ? '/LeaseMapDetail/' : '/MapDetail/';
			const w = window.screen.availWidth;
			const h = window.screen.availHeight;
			window.open(target + ri.building_uid, '', `width=${w}, height=${h}, resizable=no, status=no`);
		},
		openReadList() {
			const postUid = this.item.board_post_uid;
			this.$apiGET('/admin/api/board/read/list?id=' + postUid).then(re => {
				if (!re || !re.list || !this.isCurrent(postUid)) return;
				this.readInfo = re;
				this.readPopup = true;
			});
		},
		btnRemind() {
			// 더블클릭·응답 대기 중 재클릭이 같은 미확인자에게 쪽지를 두 번 보낸다(Codex 헌트).
			if (this.reminding) return;
			if (!confirm('미확인자에게 확인 요청 쪽지를 보내시겠습니까?')) return;
			this.reminding = true;
			this.$apiPOST('/admin/api/board/read/remind', { postUid: this.item.board_post_uid }).then(re => {
				this.reminding = false;
				if (!re || !re.ok) return;
				alert(re.sent + '명에게 알림을 보냈습니다.');
			});
		},
		addComment() {
			const memo = (this.commentMemo || '').trim();
			if (!memo) {
				alert('댓글 내용을 입력하세요.');
				return;
			}
			this.$apiPOST('/admin/api/board/comment/add', { postUid: this.item.board_post_uid, memo }).then(re => {
				if (!re || !re.ok) return;
				this.commentMemo = '';
				this.load();
			});
		},
		deleteComment(c) {
			if (!confirm('댓글을 삭제하시겠습니까?')) return;
			this.$apiPOST('/admin/api/board/comment/delete', { commentUid: c.board_comment_uid }).then(re => {
				if (re !== true) return;
				this.load();
			});
		},
		// 첨부는 /admin/api 하위라 Authorization 헤더가 필요하다 → <img src>/<video src> 로
		// 직접 URL 을 물릴 수 없다(토큰을 쿼리로 노출하는 것도 URL 로그에 남아 부적절).
		// $apiDOWN 으로 받아 blob URL 을 만들어 붙인다.
		async loadBlob(f) {
			if (this.blobUrls[f.id]) return;
			const re = await this.$apiDOWN('/admin/api/board/file/item?id=' + f.id, f.type);
			if (!re) return;
			this.blobUrls = { ...this.blobUrls, [f.id]: window.URL.createObjectURL(new Blob([re], { type: f.type })) };
		},
		revokeBlobs() {
			Object.values(this.blobUrls).forEach(u => {
				try { window.URL.revokeObjectURL(u); } catch (e) { /* 이미 해제됨 */ }
			});
			this.blobUrls = {};
		},
		// 이미지 미리보기 클릭 → 이미 받아 둔 blob 을 새 탭에서 원본 크기로 연다(재다운로드 없음).
		// SVG 는 최상위 문서로 열면 내부 스크립트가 앱 origin 에서 실행된다(업로드는 image/* 를
		// 전부 받으므로 저장형 XSS 경로가 됨) → 수동적인 래스터 포맷만 새 탭으로 열고,
		// 그 외 이미지 타입은 다운로드로 대신한다.
		openFull(f) {
			if (!SAFE_VIEW_TYPES.has(String(f.type || '').toLowerCase())) return this.downFile(f);
			const u = this.blobUrls[f.id];
			if (u) window.open(u, '_blank', 'noopener');
		},
		downFile(f) {
			this.$apiDOWN('/admin/api/board/file/item?id=' + f.id).then(re => {
				if (!re) return;
				const url = window.URL.createObjectURL(new Blob([re]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', f.org_name);
				document.body.appendChild(link);
				link.click();
				// 저장 트리거 후 정리 — 이 URL 은 blobUrls 캐시 밖이라 revokeBlobs 로 안 지워지고,
				// 동영상(최대 200MB)도 이 경로를 타서 안 지우면 SPA 내비게이션 후에도 메모리에 남는다.
				link.remove();
				setTimeout(() => window.URL.revokeObjectURL(url), 1000);
			});
		},
		sizeText(size) {
			const n = Number(size) || 0;
			if (n >= 1024 * 1024) return (n / 1024 / 1024).toFixed(1) + 'MB';
			if (n >= 1024) return Math.round(n / 1024) + 'KB';
			return n + 'B';
		},
	},
};
</script>

<style></style>
